<template>
	<div class="insight_list" aria-label="Explore Insights">

		<div class="left_nav" v-if="!isFullScreen">

			<!-- ## This Heading only showing for program insights and career insights, for explore insights its hide by css ## -->
			<div class="nav_main_hd">Alumni Insights</div>
			<!-- ## Heading end ## -->

			<simplebar class="left_nav_items" data-simplebar-auto-hide="true">
				<div>

					<template v-if="this.currentFacet === 'all'">
						<h2 class="nav_hd ace_sec_hd" :aria-label="type">{{type}}</h2>

						<div class="nav_block">
							<b-nav v-for="(insight, index) in insightsToShow && insightsToShow.length > 0 && index <= allnsightsToShow">
								<b-nav-item :active="insight.title === selectedInsight.title" :title="insight.title" @click="goToReport(insight)" :aria-label="'Alumni ' + insight.title">
									<!-- ## The thumbnail only showing for program insights and career insights, for explore insights its hide by css ## -->
									<div class="thumbnail">
										<div class="txt_bx" v-html="(insight.title).charAt(0).toUpperCase()"></div>
									</div>
									<!-- ## thumbnail end ## -->
									<v-clamp class="title_new" autoresize :max-lines="2">{{insight.title}}</v-clamp>
								</b-nav-item>
							</b-nav>
						</div>

						<div class="empty_pattern no_results ace_sec_txt" aria-label="No results" v-if="insightsToShow.length === 0">No results</div>
					</template>

					<template v-if="this.currentFacet === 'insights' && isReportReady && this.showAcademicAlumniInsights">
						<h2 class="nav_hd ace_sec_hd" aria-label="Academic Insights">Academic Insights</h2>

						<div class="nav_block">
							<b-nav v-for="(insight, index) in academicInsights" v-if="enableInsight(insight.flag) && academicInsights.length > 0 && index <= academicInsightsToShow">
								<b-nav-item :active="insight.title === selectedInsight.title" :title="insight.title" :aria-label="'Alumni' + insight.title" @click="goToReport(insight)">
									<!-- ## The thumbnail only showing for program insights and career insights, for explore insights its hide by css ## -->
									<div class="thumbnail">
										<div class="txt_bx" v-html="(insight.title).charAt(0).toUpperCase()"></div>
									</div>
									<!-- ## thumbnail end ## -->
									<v-clamp class="title_new" autoresize :max-lines="2">{{insight.title}}</v-clamp>
								</b-nav-item>
							</b-nav>
						</div>

						<div class="toggle_btn_container" v-if="academicInsightsToShow > 3">
							<b-link @click="toggleAcademicInsights(academicInsights.length)">
		    				{{this.academicInsightsToShow === 1 ? 'more' : 'less'}} {{academicInsights.length}}
		  				</b-link>
						</div>

						<div class="empty_pattern no_results ace_sec_txt" aria-label="No results" v-if="academicInsights.length === 0">No results</div>
					</template>

					<template v-if="this.currentFacet === 'insights' && isReportReady && showCareerAlumniInsights">
						<h2 class="nav_hd ace_sec_hd" aria-label="Career Insights">Career Insights</h2>

						<div class="nav_block">
							<b-nav v-for="(insight, index) in careerInsights" v-if="enableInsight(insight.flag) && careerInsights.length > 0">
                <!--
                <template v-if="index === 0">
									{{showReportOnLoad(insight)}}
								</template>
                -->
								<b-nav-item :active="insight.title === selectedInsight.title" :title="insight.title" :aria-label="'Alumni' + insight.title" @click="goToReport(insight)">
									<!-- ## The thumbnail only showing for program insights and career insights, for explore insights its hide by css ## -->
									<div class="thumbnail">
										<div class="txt_bx" v-html="(insight.title).charAt(0).toUpperCase()"></div>
									</div>
									<!-- ## thumbnail end ## -->
									<v-clamp class="title_new" autoresize :max-lines="4">{{insight.title}}</v-clamp>
								</b-nav-item>
							</b-nav>
						</div>

						<div class="toggle_btn_container" v-if="careerInsightsToShow > 3">
							<b-link @click="toggleCareerInsights(careerInsights.length)">
		    				{{this.careerInsightsToShow === 1 ? 'more' : 'less'}}
		  				</b-link>
						</div>

						<div class="empty_pattern no_results ace_sec_txt" aria-label="No results" v-if="careerInsights.length === 0">No results</div>
					</template>

          <!--
					<template v-if="this.currentFacet === 'insights' && isReportReady && showBackgroundAlumniInsights" >
						<h2 class="nav_hd ace_sec_hd" aria-label="Background Insights">Background Insights</h2>

						<div class="nav_block">
							<b-nav v-for="(insight, index) in backgroundInsights" v-if="enableInsight(insight.flag) && backgroundInsights.length > 0 && index <= backgroundInsightsToShow">
								<b-nav-item :active="insight.title === selectedInsight.title" :title="insight.title" :aria-label="'Alumni' + insight.title" @click="goToReport(insight)">

									<div class="thumbnail">
										<div class="txt_bx" v-html="(insight.title).charAt(0).toUpperCase()"></div>
									</div>

									<v-clamp class="title_new" autoresize :max-lines="2">{{insight.title}}</v-clamp>
								</b-nav-item>
							</b-nav>
						</div>

						<div class="toggle_btn_container" v-if="backgroundInsightsToShow > 3">
							<b-link @click="toggleBackgroundInsights(backgroundInsights.length)">
		    				{{this.backgroundInsightsToShow === 1 ? 'more' : 'less'}}
		  				</b-link>
						</div>

						<div class="empty_pattern no_results ace_sec_txt" aria-label="No results" v-if="backgroundInsights.length === 0">No results</div>
					</template>
          -->

				</div>
			</simplebar>

		</div>

		<div class="row pg_content">
			<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

				<div class="pg_sec">

					<div class="row">
						<div class="col-10 hd ace_sec_hd" :aria-label="selectedInsight.title">
							<h2>{{selectedInsight.title}}</h2>
							<span class="hd_bdr"></span>
						</div>
						<div class="col-2 btn_container">
							<a href="javascript:void(0)" v-if="!isFullScreen" class="hd_lnk" @click="goToFullScreen()">
								<span class="ic ic-fullscreen" title="enter full screen"></span>
							</a>
							<a href="javascript:void(0)" v-if="isFullScreen" class="hd_lnk" @click="exitFullScreen()">
								<span class="ic ic-fullscreen-exit" title="exit full screen"></span>
							</a>
						</div>
					</div>

					<div class="sec_content insights_gph_container" v-if="showReport">
						<explore-insight :insight="selectedInsight"></explore-insight>
					</div>

				</div>

			</div>
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import ExploreInsight from './ExploreInsight'
import VClamp from 'vue-clamp'
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'
export default {
  name: 'exploreInsightList',
  props: ['type', 'isAlumniInsights'],
  components: {
    ExploreInsight,
    VClamp,
    simplebar
  },
  data: () => {
    return {
      isReportReady: false,
      showReport: false,
      isFirstTimeLoad: false,
      isFullScreen: false,
      allnsightsToShow: 1,
      academicInsightsToShow: 1,
      careerInsightsToShow: 7,
      backgroundInsightsToShow: 1,
      academicInsights: [
        {
          reportName: 'Popular_Areas_of_Interest',
          targetName: 'Popular_Industries',
          flag: 'showMajorToIndustry',
          title: 'Areas of Interest to Industries',
          type: 'sankey'
        },
        {
          reportName: 'Popular_Areas_of_Interest',
          targetName: 'Popular_Career_Interests',
          flag: 'showMajorToCareer',
          title: 'Program to Career',
          type: 'sankey'
        },
        {
          reportName: 'Popular_Majors',
          targetName: 'Popular_Minors',
          flag: 'showMajorToMinor',
          title: 'Majors to Minors',
          type: 'sankey'
        },
        {
          reportName: 'Popular_Courses',
          targetName: '',
          flag: 'showPopularCourses',
          title: 'Popular Courses',
          type: 'bar'
        },
        {
          reportName: 'Popular_Areas_of_Interest',
          targetName: '',
          flag: 'showPopularMajors',
          title: 'Popular Areas of Interest',
          type: 'bar'
        }
      ],
      careerInsights: [
        {
          reportName: '',
          targetName: '',
          flag: 'showFastestGrowingCareers',
          title: 'Fastest Growing Careers (Growth Rate)',
          type: 'fastest-list'
        },
        {
          reportName: '',
          targetName: '',
          flag: 'showCareersWithLargestEmployment',
          title: 'Careers with Largest Employment (# of openings)',
          type: 'largest-list'
        },
        {
          reportName: '',
          targetName: '',
          flag: 'showCareerOptions',
          title: 'Career Options',
          type: 'tree'
        },
        {
          reportName: 'Popular_Industries',
          targetName: '',
          flag: 'showPopularPostGradIndustries',
          title: 'Popular Post Grad Industries',
          type: 'bar'
        },
        {
          reportName: 'Popular_Career_Interests',
          targetName: '',
          flag: 'showPopularCareerInterests',
          title: 'Popular Career Interests',
          type: 'bar'
        },
        {
          reportName: 'Popular_Employers',
          targetName: '',
          flag: 'showPopularPostGradEmployers',
          title: 'Popular Employers',
          type: 'bar'
        },
        {
          reportName: 'Popular_Countries',
          targetName: '',
          flag: 'showPopularPostGradCountry',
          title: 'Popular Post Grad Countries',
          type: 'bar'
        },
        {
          reportName: 'Popular_Job_Titles',
          targetName: '',
          flag: 'showPopularPostGradJobTitles',
          title: 'Popular Post Grad Job Titles',
          type: 'bar'
        }
      ],
      backgroundInsights: [
        {
          reportName: 'Popular_Previous_Industries',
          targetName: '',
          flag: 'showPopularPreviousIndustries',
          title: 'Popular Previous Industries',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Job_Areas',
          targetName: '',
          flag: 'showPopularPreviousJobs',
          title: 'Popular Previous Job Areas',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Employers',
          targetName: '',
          flag: 'showPopularPreviousEmployers',
          title: 'Popular Previous Employers',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Countries',
          targetName: '',
          flag: 'showPopularPreviousCountries',
          title: 'Popular Previous Countries',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Job_Titles',
          targetName: '',
          flag: 'showPopularPreviousJobTitles',
          title: 'Popular Previous Job Titles',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Education',
          targetName: '',
          flag: 'showPopularPreviousEducation',
          title: 'Popular Previous Education',
          type: 'bar'
        },
        {
          reportName: 'Popular_Previous_Universities',
          targetName: '',
          flag: 'showPopularPreviousUniversities',
          title: 'Popular Previous Universities',
          type: 'bar'
        }
      ],
      exploreInsightsFlags: {},
      selectedInsight: {}
    }
  },

  created () {
    this.isFirstTimeLoad = true
  },

  mounted () {
    this.setupExploreInsightsFlags()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'setCurrentFacet'
    ]),
    setupExploreInsightsFlags () {
      if (this.enabledFeatures) {
        let firstInsight = this.careerInsights[0]
        var academicInsightsfeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.ACADEMIC_ALUMNI_INSIGHTS_FEATURE_ID]
        if (academicInsightsfeature) {
          let flags = academicInsightsfeature.flags
          for (var i = 0; i < flags.length; i++) {
            this.exploreInsightsFlags[flags[i].title] = flags[i].enabled
          }
        }

        var careerInsightsfeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CAREER_ALUMNI_INSIGHTS_FEATURE_ID]
        if (careerInsightsfeature) {
          let flags = careerInsightsfeature.flags
          for (var j = 0; j < flags.length; j++) {
            if (this.isAlumniInsights && (flags[j].title === 'showFastestGrowingCareers' || flags[j].title === 'showCareersWithLargestEmployment')) {
              this.exploreInsightsFlags[flags[j].title] = false
              firstInsight = this.academicInsights[1]
            } else {
              this.exploreInsightsFlags[flags[j].title] = flags[j].enabled
            }
          }
        }

        var backgroundInsightsfeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BACKGROUND_ALUMNI_INSIGHTS_FEATURE_ID]
        if (backgroundInsightsfeature) {
          let flags = backgroundInsightsfeature.flags
          for (var z = 0; z < flags.length; z++) {
            this.exploreInsightsFlags[flags[z].title] = flags[z].enabled
          }
        }
        this.isReportReady = true
        this.showReportOnLoad(firstInsight)
        if (this.isAlumniInsights) {
          this.careerInsightsToShow = 3
        }
      }
    },
    showMore () {
      this.setCurrentFacet(this.type)
    },
    showReportOnLoad (insight) {
      if (this.isFirstTimeLoad === true) {
        setTimeout(() => {
          this.goToReport(insight)
          this.isFirstTimeLoad = false
        }, 100)
      }
    },
    goToReport (insight) {
      this.resetInsights()
      setTimeout(() => {
        this.selectedInsight = insight
        this.showReport = true
        this.setCurrentFacet(this.type)
      }, 100)
    },
    resetInsights () {
      this.showReport = false
      this.selectedInsight = {}
    },
    enableInsight (flag) {
      if (this.exploreInsightsFlags[flag]) {
        return this.exploreInsightsFlags[flag]
      }
      return false
    },
    goToFullScreen () {
      this.isFullScreen = true
      $('.explore_entity_inside').addClass('full_screen')
    },
    exitFullScreen () {
      this.isFullScreen = false
      $('.explore_entity_inside').removeClass('full_screen')
    },
    toggleAcademicInsights (totalInsights) {
      if (this.academicInsightsToShow === totalInsights) {
        this.academicInsightsToShow = 1
      } else {
        this.academicInsightsToShow = totalInsights
      }
    },
    toggleCareerInsights (totalInsights) {
      if (this.careerInsightsToShow === totalInsights) {
        this.careerInsightsToShow = 1
      } else {
        this.careerInsightsToShow = totalInsights
      }
    },
    toggleBackgroundInsights (totalInsights) {
      if (this.backgroundInsightsToShow === totalInsights) {
        this.backgroundInsightsToShow = 1
      } else {
        this.backgroundInsightsToShow = totalInsights
      }
    }
  },

  computed: {
    ...mapState({
      'enabledFeatures': state => state.institution.enabledFeatures,
      'currentFacet': state => state.explore.currentFacet
    }),

    showAcademicAlumniInsights () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.ACADEMIC_ALUMNI_INSIGHTS_FEATURE_ID]
      if (feature && feature.enabled) {
        return true
      }
      return false
    },

    showCareerAlumniInsights () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CAREER_ALUMNI_INSIGHTS_FEATURE_ID]
      if (feature && feature.enabled) {
        return true
      }
      return false
    },

    showBackgroundAlumniInsights () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BACKGROUND_ALUMNI_INSIGHTS_FEATURE_ID]
      if (feature && feature.enabled) {
        return true
      }
      return false
    },

    enableShowMore () {
      if (this.currentFacet === 'all') {
        return true
      }
      return false
    },

    insightsToShow () {
      // return one from each group
      var t = []
      t.push(this.careerInsights[0])
      return t
    }

  },

  watch: {
    currentFacet (newCurrentFacet) {
      if (newCurrentFacet !== 'insights') {
        this.resetInsights()
      }
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreInsightList.vue